import React, { useEffect, useState } from "react";
import api from "../api";
import "../App.css";

const LABEL = {
  waiting: "대기",
  sending: "보내는 중",
  done: "발송함",
  canceled: "취소됨",
  error: "오류",
};

function when(v) {
  if (!v) return "";
  return String(v).replace("T", " ").replace(/\.\d+Z?$/, "").slice(0, 16);
}

const Schedules = () => {
  const [rows, setRows] = useState([]);
  const [notice, setNotice] = useState("");

  const load = () => api.get("/ui/schedules").then((r) => setRows(r.data.rows || [])).catch(() => {});
  useEffect(() => { load(); }, []);

  const cancel = async (id) => {
    if (!window.confirm("이 예약을 취소할까요?")) return;
    await api.delete(`/ui/schedules/${id}`);
    setNotice("취소했습니다.");
    load();
  };

  return (
    <div className="schedules">
      <h2 className="title">예약함</h2>
      {notice && <div className="notice">{notice}</div>}

      <table className="tbl wide">
        <thead>
          <tr>
            <th style={{ width: 140 }}>보낼 시각</th>
            <th style={{ width: 80 }}>상태</th>
            <th style={{ width: 60 }}>건수</th>
            <th>내용</th>
            <th style={{ width: 90 }}>만든 사람</th>
            <th style={{ width: 80 }}></th>
          </tr>
        </thead>
        <tbody>
          {rows.map((r) => (
            <tr key={r.id}>
              <td>{when(r.sendAt)}</td>
              <td>
                <span className={"state " + (r.status === "waiting" ? "wait" : r.status === "error" ? "bad" : r.status === "done" ? "ok" : "")}>
                  {LABEL[r.status] || r.status}
                </span>
              </td>
              <td>{r.total}</td>
              <td className="content"><pre>{r.content}</pre>{r.note && <div className="reason">{r.note}</div>}</td>
              <td>{r.userId}</td>
              <td>
                {r.status === "waiting" && (
                  <button className="btn ghost sm" onClick={() => cancel(r.id)}>취소</button>
                )}
              </td>
            </tr>
          ))}
          {!rows.length && <tr><td colSpan={6} className="empty">예약된 발송이 없습니다.</td></tr>}
        </tbody>
      </table>
    </div>
  );
};

export default Schedules;
